import {Configuration} from '@shared/models/configuration';

// @dynamic
export class OrbitaxExcelMemoConfig {
  public static get ITRCEApi(): string {
    return Configuration.ITRCEApi;
  }

  static GetExcelMemoApi(id: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/ExcelMemo?id=${id}&projectId=[PROJECT_ID]`;
  }

  static GetWithholdingTaxMemoApi(id: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/WithholdingTaxMemo?id=${id}&projectId=[PROJECT_ID]`;
  }

  static SaveWithholdingTaxMemoApi(id: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/SaveWithholdingTaxMemo?id=${id}&projectId=[PROJECT_ID]`;
  }

  static SaveCorporateTaxMemoApi(id: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/SaveCorporateTaxMemo?id=${id}&projectId=[PROJECT_ID]`;
  }

  static GetCoporateTaxMemoApi(id: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/CorporateTaxMemo?id=${id}&projectId=[PROJECT_ID]`;
  }

  static get CreateEmptyMemoApi(): string {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Command/CreateEmptyMemo`;
  }

  static get UpdateMemoApi(): string {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Command/UpdateMemo`;
  }

  static get UpdateTaskMemoReportApi(): string {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Command/UpdateTaskMemoReport`;
  }

  static ViewMemoApi(id: string, memoType: string) {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/ViewMemo?id=${id}&projectId=[PROJECT_ID]&memoType=${memoType}`;
  }

  static get DownloadExcelMemoReportApi(): string {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Command/DownloadExcelMemoReport`;
  }

  static DownloadMemoApi(id: string, memoType: string): string {
    return `${OrbitaxExcelMemoConfig.ITRCEApi}Memo/DownloadMemo?id=${id}&projectId=[PROJECT_ID]&memoType=${memoType}`;
  }
}
